var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.945,
    height: 12.928,
    viewBox: "0 0 12.945 12.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "excel2-svgrepo-com",
    transform: "translate(-2 -2.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M14.381,3.122H9.7v-1.1L2,3.206V13.621l7.7,1.326V13.311h4.683a.537.537,0,0,0,.564-.507V3.628a.537.537,0,0,0-.564-.506Zm.074,9.767H9.682l-.008-.873h1.15V11H9.666l-.006-.6h1.164V9.38H9.651l-.006-.6h1.178V7.762H9.642v-.6h1.182V6.144H9.642v-.6h1.182V4.526H9.642V3.6h4.813Z",
    fill: "#20744a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_525",
    "data-name": "Rectangle 525",
    width: 1.999,
    height: 1.017,
    transform: "translate(11.471 4.524)",
    fill: "#20744a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_526",
    "data-name": "Rectangle 526",
    width: 1.999,
    height: 1.017,
    transform: "translate(11.471 6.143)",
    fill: "#20744a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_527",
    "data-name": "Rectangle 527",
    width: 1.999,
    height: 1.017,
    transform: "translate(11.471 7.761)",
    fill: "#20744a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_528",
    "data-name": "Rectangle 528",
    width: 1.999,
    height: 1.017,
    transform: "translate(11.471 9.38)",
    fill: "#20744a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_529",
    "data-name": "Rectangle 529",
    width: 1.999,
    height: 1.017,
    transform: "translate(11.471 10.998)",
    fill: "#20744a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M6.248,10.458,7.24,10.4l.624,1.715L8.6,10.331l.992-.057-1.2,2.435,1.2,2.441-1.049-.071-.708-1.86-.709,1.79-.964-.085,1.12-2.156Z",
    transform: "translate(-2.238 -4.439)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.8e2b28c764cef5400d4ea325894e79ea.svg";
export { ForwardRef as ReactComponent };